export default "__VITE_ASSET__BveAX8oh__"